import { Button } from "@/components/common";
import { useAuth } from "@/context";
import { HeaderProps } from "@/types/components";
import { cn } from "@/utils/cn";
import { Menu } from "lucide-react";
import React from "react";

export const Header: React.FC<HeaderProps> = ({
  title,
  onMenuToggle,
  className = "",
}) => {
  const { logout, user } = useAuth();

  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 px-6 py-4 shadow-sm",
        className
      )}
    >
      <div className="flex items-center justify-between">
        {/* Left Section */}
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuToggle}
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Toggle menu"
          >
            <Menu size={20} />
          </button>

          <div className="flex items-center space-x-3">
            <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-3">
          {/* User Info */}
          <div className="flex items-center space-x-3">
            <div className="text-sm text-gray-600">
              <span className="font-medium">Usuário:</span>{" "}
              {user?.preferred_username ||
                user?.name ||
                user?.email ||
                "Carregando..."}
            </div>
            <Button variant="danger" size="sm" onClick={logout}>
              Logout
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
